












































// require('./lib/ui/root.js');

import ripple from "../../components/ripple.vue"
import tooltip from "../../components/tooltip.vue"
import gbutton from "../../components/button.vue"
import graph from "../../components/lineGraph.js"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { frontendClient } from "../../lib/client";
import moment,{ weekdays, invalid} from "moment";
import { setInterval } from "timers";

@Component({
    components : {
        ripple,
        gbutton,
        graph,
        tooltip,
    },
})
export default class Alerts extends Vue{
    alerts:{
        title: string,
        body: string,
        timestamp: number,
        date:(String | Date);
    }[] = null;

    mounted(){
       this.$emit('scope','alerts');
       this.getAlerts();

       //moment(this.alert.timestamp).format("ddd, DD/MM/YYYY")
    }

    async getAlerts(){
        this.alerts = await frontendClient.post("alerts/latest",{});

        for(let i=0; i<this.alerts.length; i++){
            this.alerts[i].date = moment(this.alerts[i].timestamp).format("ddd, DD/MM/YYYY");
        }
    }
}
